var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComputingAndSoftware(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M22.77 1.28A1.1 1.1 0 0 0 22 .61C19-.37 4.44-.06 3.25.8a.34.34 0 0 0 .39.56C4.73.6 18 .67 21.33 1.47c.2.06.38.22.48.22.55 2.67.63 2.92-.07 9.92-10.23-.29-12.44-.35-18.23-.17-1.15-.06-1.16-.19-1.33 0-.07-.67-.16-3.63-.1-5.59.1-3.45.52-3.77 0-3.85a.31.31 0 0 0-.34.26 51.69 51.69 0 0 0-.39 8.91 8.48 8.48 0 0 0 .78 3.46c.91 1.25 16.44 1 18.71.85.56-.05 1.26-.07 1.43-.57a20.44 20.44 0 0 0 .7-4.55c.37-4.81.69-5.19-.2-9.08Zm-1.51 13.06c-2.62.2-15.88.4-18.46-.29a8.12 8.12 0 0 1-.57-2.19c.13.11.25.14 1.22.25a134.47 134.47 0 0 0 18.21.19 12.91 12.91 0 0 1-.4 2.04Z",
    fill: "#B557F7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.76 17c-.67-.33-13.11-.18-13.88-.17a.34.34 0 0 0 0 .68c1.27 0 12.17.19 13.3.36.05.13.28.43.43.77A24.89 24.89 0 0 1 21 22.71c-1.73.2-15.23.25-18.71 0-.38 0-.72-.19-.89-.19.12-1.17 2.58-4.74 2.8-4.86a.3.3 0 0 0-.28-.53 22.05 22.05 0 0 0-2.7 3.77A3.11 3.11 0 0 0 .71 23c.13.33.65.39 1.1.46 3.9.55 19 .78 20 .26a.69.69 0 0 0 .36-.5c.19-1.03-1.78-5.97-2.41-6.22Z",
    fill: "#B557F7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.48 21.8c5 .55 5.52 0 7.77.1a.34.34 0 0 0 .06-.68 26.46 26.46 0 0 0-7.81 0 .3.3 0 0 0-.02.58Z",
    fill: "#8841B9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.09 21c-.35 0-1.3.29-1.3.58 0 .58 1.54.55 2.3.34a.34.34 0 0 0 .34-.34c0-.4-1.07-.58-1.34-.58Z",
    fill: "#8841B9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.79 21c-.36 0-1.3.29-1.3.58 0 .58 1.54.55 2.3.34a.35.35 0 0 0 .34-.34c0-.4-1.07-.58-1.34-.58Z",
    fill: "#8841B9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.38 18.82c-.35 0-1.3.29-1.3.58 0 .58 1.54.55 2.3.33a.34.34 0 0 0 .34-.34c0-.39-1.07-.57-1.34-.57Z",
    fill: "#8841B9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.59 18.82c-.35 0-1.3.29-1.3.58 0 .58 1.54.55 2.3.33a.34.34 0 0 0 .34-.34c0-.39-1.07-.57-1.34-.57Z",
    fill: "#8841B9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.8 18.82c-.35 0-1.3.29-1.3.58 0 .58 1.54.55 2.3.33a.34.34 0 0 0 .34-.34c0-.39-1.07-.57-1.34-.57Z",
    fill: "#8841B9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 18.82c-.35 0-1.3.29-1.3.58 0 .58 1.54.55 2.3.33a.34.34 0 0 0 .34-.34c.01-.39-1.06-.57-1.34-.57Z",
    fill: "#8841B9",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputingAndSoftware);
export default __webpack_public_path__ + "static/media/computing-and-software.550f45aa86650d8ebca57ae51867c61e.svg";
export { ForwardRef as ReactComponent };